window.addEventListener("globoRelatedProductsUpdateCart",function(e){const cart_counts=document.getElementsByClassName("header__cart-count");cart_counts.length>0&&(cart_counts[0].innerHTML=e.detail.cart.item_count)});
//# sourceMappingURL=/cdn/shop/t/13/assets/custom.js.map?v=14769833947148490611779884257

/* Dronefly: instantly show a "Fá tilkynningu" button on sold-out collection/search cards,
   and open Kbite's back-in-stock popup inline on click (lazy — no per-product prefetch). */
(function () {
  try {
    // Runs on any page that has product cards (home, collections, search, product-page carousels, etc.)
    if (window.__dfNotifyGrid) return;
    window.__dfNotifyGrid = true;

    var NOTIFY_TEXT = "Fá tilkynningu";
    var bell = "url(\"data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20width='14'%20height='14'%20viewBox='0%200%2024%2024'%20fill='none'%20stroke='%23666'%20stroke-width='1.8'%20stroke-linecap='round'%20stroke-linejoin='round'%3E%3Cpath%20d='M18%208a6%206%200%200%200-12%200c0%207-3%209-3%209h18s-3-2-3-9'/%3E%3Cpath%20d='M13.73%2021a2%202%200%200%201-3.46%200'/%3E%3C/svg%3E\")";

    var style = document.createElement("style");
    style.textContent =
      ".df-notify-link{display:inline-flex!important;align-items:center;gap:6px;margin-top:6px;padding:0;" +
      "background:none;border:none;box-shadow:none;width:auto;line-height:1.2;font:inherit;font-size:13px;" +
      "font-weight:400;color:rgba(0,0,0,0.6);cursor:pointer;text-decoration:none;}" +
      ".df-notify-link::before{content:'';flex:0 0 14px;width:14px;height:14px;background:" + bell +
      " no-repeat center center;background-size:contain;opacity:0.7;}" +
      ".df-notify-link:hover{color:rgba(0,0,0,0.9);text-decoration:underline;}" +
      ".df-notify-link.df-loading{opacity:0.45;pointer-events:none;}" +
      /* Fix: keep the product-card price on its own line below the title
         (it was sitting beside short single-line titles on mobile). */
      ".product-item__price-list{display:flex!important;width:100%;}" +
      ".product-item__info-inner>.product-item__title{display:block!important;width:100%;}";
    document.head.appendChild(style);

    function isSoldOut(card) {
      var inv = card.querySelector(".product-item__inventory");
      if (!inv) return false;
      // sold-out renders a bare ".inventory" (no --high / --low modifier)
      return inv.classList.contains("inventory") &&
             !inv.classList.contains("inventory--high") &&
             !inv.classList.contains("inventory--low");
    }

    function whenKbiteReady(cb) {
      if (window.initVar && typeof window.initVar === "object") { cb(true); return; }
      var n = 0;
      var iv = setInterval(function () {
        n++;
        if (window.initVar && typeof window.initVar === "object") { clearInterval(iv); cb(true); }
        else if (n > 60) { clearInterval(iv); cb(false); }
      }, 100);
    }

    function openNotify(handle, el) {
      el.classList.add("df-loading");
      whenKbiteReady(function (ready) {
        if (!ready) { el.classList.remove("df-loading"); window.location.href = handle; return; }
        fetch(handle + ".js", { credentials: "same-origin" })
          .then(function (r) { return r.json(); })
          .then(function (p) {
            var v = (p.variants && (p.variants.filter(function (x) { return !x.available; })[0] || p.variants[0])) || {};
            var btn = document.createElement("button");
            btn.setAttribute("data-product-id", p.id);
            btn.setAttribute("data-variant-id", v.id);
            btn.setAttribute("data-product-handle", p.handle);
            btn.style.display = "none";
            document.body.appendChild(btn);
            try { window.initVar.processProduct(p); } catch (e) {}
            try { window.initVar.addPopUp(window.initVar.stockWidget.popupSelector, window.initVar.stockWidget.modalHtml); } catch (e) {}
            try { window.initVar.stockWidgetClicked({ preventDefault: function () {}, stopPropagation: function () {}, target: btn, currentTarget: btn }); } catch (e) {}
            el.classList.remove("df-loading");
          })
          .catch(function () { el.classList.remove("df-loading"); window.location.href = handle; });
      });
    }

    function addBtn(card) {
      if (card.querySelector(".df-notify-link")) return;
      var titleLink = card.querySelector(".product-item__title");
      if (!titleLink) return;
      var handle = (titleLink.getAttribute("href") || "").split("?")[0];
      if (!handle) return;
      var a = document.createElement("a");
      a.href = handle;
      a.className = "df-notify-link";
      a.setAttribute("role", "button");
      a.setAttribute("aria-label", NOTIFY_TEXT);
      a.textContent = NOTIFY_TEXT;
      a.addEventListener("click", function (ev) { ev.preventDefault(); ev.stopPropagation(); openNotify(handle, a); });
      // Append INSIDE info-inner (right under the status) so flex space-between on the
      // card (e.g. equal-height homepage carousel cards) can't push the button to the bottom.
      var anchor = card.querySelector(".product-item__info-inner");
      if (anchor) anchor.appendChild(a);
      else card.appendChild(a);
    }

    function scan() {
      var cards = document.querySelectorAll(".product-item");
      for (var i = 0; i < cards.length; i++) { if (isSoldOut(cards[i])) addBtn(cards[i]); }
    }

    scan();
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
    var c = 0;
    var iv = setInterval(function () { c++; scan(); if (c > 12) clearInterval(iv); }, 300);
    // re-scan shortly after user interactions (covers AJAX filter / pagination) without a mutation-observer loop
    document.addEventListener("click", function () { setTimeout(scan, 500); }, true);
  } catch (e) {}
})();
